var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chips__supplied"},_vm._l((_vm.chipsData),function(item,index){return _c('span',{key:item,staticClass:"chip__wrap"},[_vm._v(_vm._s(item)+" "),(_vm.isRemoveShow)?_c('i',{staticClass:"ti-close",on:{"click":function($event){return _vm.removeChip(index)}}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }